/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const EnvironmentDeleteResponse = zod
	.object({
		message: zod.string().describe('Success message')
	})
	.describe('Environment deletion response');

export type EnvironmentDeleteResponse = zod.input<typeof EnvironmentDeleteResponse>;
export type EnvironmentDeleteResponseOutput = zod.output<typeof EnvironmentDeleteResponse>;
